/**
 * @constant {string} body_html 
 */
export default body_html => (body_html || "").replace("\n        ", "").match(/{(.*)}/)
